
<template>
<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.46967 4.78033C1.17678 4.48744 1.17678 4.01256 1.46967 3.71967C1.73594 3.4534 2.1526 3.4292 2.44621 3.64705L2.53033 3.71967L6 7.189L9.46967 3.71967C9.73594 3.4534 10.1526 3.4292 10.4462 3.64705L10.5303 3.71967C10.7966 3.98594 10.8208 4.4026 10.6029 4.69621L10.5303 4.78033L6.53033 8.78033C6.26406 9.0466 5.8474 9.0708 5.55379 8.85295L5.46967 8.78033L1.46967 4.78033Z" fill="black"/>
</svg>
</template>
    
<script>
export default {
  components: {
  },
  props: {
  },
  data() {
    return {
    }
  },
}
</script>

<style lang="scss" scoped>
svg {
  height: 18px;
}  
</style>
  
    